import * as util from "./util";

export function logBusinessActivities (description, id, categories, price, fee) {
  var headers = util.defaultHeaders();
  var formData = new FormData();
  var url = `/api/logbusinessactivities`;
  formData.append("description", description);
  formData.append("activity_id", id);
  if(categories !== undefined) {
    formData.append("categories", categories);
  }
  if(price !== undefined) {
    formData.append("price", price);
  }
  if(fee !== undefined) {
    formData.append("fee", fee);
  }
  var promise = fetch(url, {method: 'POST',
                            headers: headers,
                            body: formData
  })
    .then(response => response.json())
    .catch(function(exception) {
      console.error(`Could not log business activity data!`, exception);
    });
  promise.then(function(json) {
    return true;
  })
  return true;
}



// WEBPACK FOOTER //
// ./src/business_activities.js